import { useQuery } from '@tanstack/react-query';
import type { SessionUser } from '@voice/shared';
import { ApiError, api } from './api';

export const ME_KEY = ['me'] as const;

/** `null` = nicht angemeldet, `undefined` = lädt noch. */
export function useMe() {
  return useQuery<SessionUser | null>({
    queryKey: ME_KEY,
    queryFn: async () => {
      try {
        return await api<SessionUser>('/me');
      } catch (err) {
        if (err instanceof ApiError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 60_000,
    retry: false,
  });
}
